import { useMainStore, useTemplatesStore } from '@/store'
import { Canvas, Object as FabricObject, Image } from 'fabric'
import { shallowRef } from 'vue'
import { toRef } from './attribute/toRef'
import { check } from '@/utils/check'
import { nonid } from '@/utils/common'
import { FabricRuler } from './fabricRuler'

export class FabricCanvas extends Canvas {
  public ruler?: FabricRuler
  public loading?: Image 
  public activeObject = shallowRef<FabricObject>() as any

  constructor(el: string | HTMLCanvasElement, options?: any) {
    // @ts-ignore
    super(el, options)
  }

  // @ts-ignore
  public get _activeObject() {
    return (this.activeObject && this.activeObject.value) ? this.activeObject.value : undefined
  }

  public set _activeObject(value) {
    const mainStore = useMainStore()
    mainStore.setCanvasObject(value as FabricObject)
    if (this.activeObject) {
      this.activeObject.value = value
    }
  }

  // @ts-ignore
  override add(...objects: FabricObject[]): any {
    return (super.add as any)(
      ...objects.map((obj) => {
        this.setDefaultAttr(obj)
        return toRef(obj)
      }),
    )
  }

  // @ts-ignore
  override insertAt(index: number, ...objects: FabricObject[]): any {
    return (super.insertAt as any)(
      index,
      ...objects.map((obj) => {
        this.setDefaultAttr(obj)
        return toRef(obj)
      }),
    )
  }

  private setDefaultAttr(target: FabricObject) {
    // 添加name
    if (!target.name) {
      (target as any).set({name: target.type})
    }
    // 添加id
    if (!target.id) {
      (target as any).set({id: nonid(8)})
    }
    if (check.isTextObject(target)) {
      (target as any).set({color: (target as any).fill})
    }
    if (check.isCollection(target)) {
      (target as any)._objects?.forEach((obj: any) => {
        this.setDefaultAttr(obj)
      })
    }
  }
}